<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <label for="">
          {{ $resourceString["contentWizard.Label.ImageType"] }}
        </label>
        <div class="mb-2 justify-content-between align-items-center">
          <div class="input-group">
            <select
              @change="handleImageType"
              name="galleryImageType"
              class="form-control form-control-sm text-capitalize"
              :id="selectedOption"
              required="required"
              v-model="selectedOption"
            >
            <option value :selected="true" disabled
                >{{ $resourceString["contentWizard.ImageType.Dropdown.Label.Default"] }}</option
              >
              <option
                v-for="(item, index) in getimageTypeFilters"
                :key="index"
                :value="item == 'Projects'?'ProjectType':item + 'Type'"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="pl-3 pt-3">
        <label for="">
          {{ $resourceString["contentWizard.Label.AddImage"] }}
        </label>
      </div>
      <gallery-Images-Search :cols="'sm-12'" :placeholderName="$resourceString['contentWizard.Label.SearchField.Placeholder']" />
    </div>

    <div
      class="row mt-2"
      :class="inspirationGalleryData.length > 3 ?'inspiration-gallery-item-container':''"
      v-if="inspirationGalleryData"
    >
      <div
        class="col-sm-4"
        v-for="(item, index) in inspirationGalleryData"
        :key="index"
      >
        <div
          @click="updateImage(item)"
          class="swiper-slide swiper-slide-visible swiper-slide-active mb-2"
          :class="
            item.id == getselectedTrayId
              ? 'my-project-feature-image-active'
              : ''
          "
        >
          <div class="wf-product-quick-view-swatch-slide">
            <div class="wf-product-quick-view-swatch-slide-image">
              <img
                class="room-img-thumb"
                :src="$helpers.getWidenImgURL(item.embedId, 1000)"
                :alt="item.imageAltText || ''"
                :style="{ backgroundColor: item.embedId ? '' : '#9f9e9e' }"
              />
            </div>
          </div>
          <div class="medium mb-2 px-2 w-100 text-size-xsmall text-left">
            {{ item.mainProduct.sellingStyleName }}
          </div>
        </div>
      </div>
      <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
      <div
        v-if="inspirationGalleryData.length == 0 && !showLoadMore"
        class="container"
      >
        <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import galleryImagesSearch from "./galleryImagesSearch.vue";
import { mapActions, mapGetters } from "vuex";
import PcLoadMore from "../../../common/pc-loading-more.vue";
export default {
  data() {
    return {
      showClearIcon: false,
      selectedOption: "",
  }
  },

  components: {
    galleryImagesSearch,
    PcLoadMore
  },

  mounted() {
    this.updateSelectedImageType("DisplayCollectionName");
    this.updateSearchInput("");
    this.updateInspirationGalleryImages();
  },

  computed: {
    ...mapGetters({
      inspirationGalleryData: "contentWizard/getinspirationGalleryImages",
      showLoadMore: "contentWizard/getShowLoadMore",
      isFetching: "contentWizard/getLoader",
      getselectedTrayId: "contentWizard/getselectedTrayId",
      getimageTypeFilters:"contentWizard/getimageTypeFilters"
    }),


  },
  methods: {
    ...mapActions({
      loadMoreData: "contentWizard/loadMoreData",
      updateSelectedImageType: "contentWizard/updateSelectedImageType",
      updateselectedTrayId: "contentWizard/updateselectedTrayId",
      updateSearchInput: "contentWizard/updateSearchInput",
      setContentItem: "contentWizard/setContentItem",
      updateInspirationGalleryImages: "contentWizard/updateInspirationGalleryImages"
    }),
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.loadMoreData();
      this.updateInspirationGalleryImages();
    },
    updateImage(item) {
      if (item.id) {
        this.updateselectedTrayId(item.id);
        this.setContentItem({
          title: item.mainProduct.sellingStyleName,
          coverPhoto: this.$helpers.getWidenImgURL(item.embedId, 1000),
          coverPhotoImageAltText: item?.imageAltText ?? "",
          itemBoardId: item.id
        });
      } else {
        this.updateselectedTrayId("");
      }
    },
    handleImageType() {
      this.updateSelectedImageType(this.selectedOption);
      this.updateInspirationGalleryImages();
    }
  }
};
</script>
